import { ethers, providers, Wallet } from 'ethers';

export async function getEthereumWallet(privateKey: string, rpcProvider: providers.JsonRpcProvider): Promise<{ address: string; balance: number }> {
    const wallet = new Wallet(privateKey, rpcProvider);
    const balance = await wallet.getBalance();

    return { balance: Number(ethers.utils.formatEther(balance)), address: wallet.address };
}
